import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import { withRouter } from 'react-router-dom';

import Spinner from "@sm/components/Spinner";
import Table from "@sm/components/custom/Table";

import "@assets/css/apiData.css";

import { DASHBOARD_WITHDRAWAL_REQUESTS } from "@sm/actions/types";
import { toFormattedNumber } from "@sm/utils/utils";
import { DATA_TYPES } from "@modules/data/ManualInput";

const store = require("@sm/reducers/index");

class DashBoardWithdrawalRequestsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      withdrawalRequests: undefined,
      loading: false,

      columns: [
        {
          value: "dateTime",
          label: "Date",
          isNumber: false,
          isDate: true,
          leftAligned: true,
        },
        {
          value: "merchantName",
          label: "Merchant",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "currency",
          label: "Currency",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "amount",
          label: "Amount",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "id",
          label: "Action",
          centerAligned: true,
          className: "btn view-settlement",
          buttonLabel: "View",
          isButton: true,
          triggerEvent: (data) => this.viewWithdrawalRequest(data),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        }
      ]
    };
  }

  subscribeFunction = null;

  componentDidMount() {
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({ loading: true });
      }

      if (state.update === DASHBOARD_WITHDRAWAL_REQUESTS) {
        this.setState({
          withdrawalRequests: state.withdrawalRequests,
          loading: false
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  }

  tableData = () => {
    const { withdrawalRequests } = this.state;

    if (!withdrawalRequests) {
      return [];
    }

    return withdrawalRequests.map((elem) => {
      return {
        ...elem,
        amount: toFormattedNumber(elem.amount),
      };
    });
  };

  viewWithdrawalRequest = (data) => {
    this.props.history.push({
      pathname: "/otc-settlements",
      state: {
        ...data,
        otc: true,
        merchantId: [data.merchantId],
        dataType: DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST
      }
    });
  };

  render() {
    const { withdrawalRequests, loading, columns } = this.state;

    return (
      <Panel style={ { height: "100%" } }>
        <Panel.Heading>
          <Panel.Title> PENDING WITHDRAWAL REQUESTS </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {loading && !withdrawalRequests ? (
            <Spinner smallContainer={ true } />
          ) : (
            <div className="panel-content table-content ">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
              />
            </div>
          )}
        </Panel.Body>
      </Panel>
    );
  }
}

export default withRouter(DashBoardWithdrawalRequestsComponent);
